type MarketingLocale = "hr" | "en"

export function localizedHomeUrl(locale: MarketingLocale) {
  return locale === "hr" ? "https://zmile.hr/" : "https://zmile.hr/en"
}

export function marketingBreadcrumbs({
  canonicalUrl,
  locale,
  title,
}: {
  canonicalUrl: string
  locale: MarketingLocale
  title: string
}) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: locale === "hr" ? "Početna" : "Home",
        item: localizedHomeUrl(locale),
      },
      {
        "@type": "ListItem",
        position: 2,
        name: title,
        item: canonicalUrl,
      },
    ],
  }
}
